 var _createCookie = function(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + ";domain=.charliehustle.com;path=/";
};

var _readCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)===' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
};

  function customOnLoad(){
    let hasCookie = _readCookie("viewedHSFormModal");
      let hsform = document.getElementById('hsFormModal');
    if(!hasCookie)
    {
      _createCookie("viewedHSFormModal", "true", 30);
      if(hsform){
        hsform.classList.add("show");
        console.log('show')
      }
    }
    document.querySelector('#hsFormModal .modal__close').addEventListener("click", function(e){
      e.preventDefault();
      hsform.classList.remove("show");
    })
  }
  

document.addEventListener('DOMContentLoaded', customOnLoad, false);
